import { IPlanContent } from '../typings';
import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import { defaultEstimatesDialog, ongoingKeyDetails } from './common/planDefaults';

const PLAN_TONE = 'promote';
const PLAN_NAME = 'Origin Business Go Community Battery';

export const originBusinessCommBatSharePlanContent: IPlanContent = {
  test: createPlanNameMatcher([PLAN_NAME]),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on an ongoing contract',
      },
    },
    keyFeatures: {
      defaultState: {
        defaultFuel: [],
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: ongoingKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: [],
        gas: [],
        electricity: [],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'blue',
              odsCore: PLAN_TONE,
            },
            promobox: {
              styleGuide: 'blue',
              odsCore: PLAN_TONE,
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
          imageUrl:
            'https://res.cloudinary.com/originenergy/image/upload/v1729663222/spot-illustrations/spot-default-plan.svg',
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-community-battery-share.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-community-battery-share.svg',
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel: 'Enjoy the shared benefits of your local community battery',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel:
          'https://www.originenergy.com.au/terms-and-conditions/business-go-community-battery/',
      },
    },
    estimatesDialog: defaultEstimatesDialog({ customerType: 'business' }),
  },
};
